// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + chunkId + ".js?v=" + {"4720":"3579bbfdda4bbff89d5b","9847":"a7a97acf5197f82da3fe"}[chunkId] + "";
};